import React, { useState } from 'react';
import PopOver from '@mui/material/Popover';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import AssignMemberSearch from '../AssignMemberSearch';
import { CAN_EDIT_TEAM_MEMBERS } from '../../constants/permissions';
import useProjectVersionHistory from '../../context/VersionHistoryContext';
import useWorkspace from '../../context/WorkspaceContext';

const propTypes = {
  tableId: PropTypes.string.isRequired,
  skillId: PropTypes.number.isRequired,
  getTeamMembers: PropTypes.func.isRequired,
  techMember: PropTypes.array.isRequired,
};

const AssignMemberPopOver = ({ tableId, skillId, techMember, getTeamMembers }) => {
  const { userPermissions } = useWorkspace();
  const [anchorEl, setanchorEl] = useState(null);
  const { selectedListItem, showVersionHistoryBar, readOnlyMode } = useProjectVersionHistory();
  const permission = [];
  if (userPermissions !== undefined) {
    if (userPermissions.permissions !== undefined) {
      userPermissions.permissions.map((x) => permission.push(x));
    }
  }
  const handleClick = (event) => {
    setanchorEl(event.currentTarget);
  };

  const handleOnChange = () => {
    setanchorEl(null);
  };

  const isHidden =
    showVersionHistoryBar &&
    readOnlyMode &&
    selectedListItem !== null &&
    selectedListItem !== undefined;

  const open = Boolean(anchorEl);

  return (
    <div>
      {permission.includes(CAN_EDIT_TEAM_MEMBERS) && (
        <Button disabled={isHidden} className="assign-member-list" onClick={handleClick}>
          Assign Member
        </Button>
      )}
      <PopOver
        className="assign-member-popover"
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        onClose={handleOnChange}
      >
        <AssignMemberSearch
          className="assign-member-search-list"
          skillId={skillId}
          tableId={tableId}
          userList={techMember}
          closePopoverHandler={() => setanchorEl(null)}
          getTeamMembers={getTeamMembers}
          handleOnChange={handleOnChange}
        />
      </PopOver>
    </div>
  );
};

AssignMemberPopOver.propTypes = propTypes;
export default AssignMemberPopOver;
